import { mapProductPrice, RawProductPrice } from '~/Api/Product';
import Price from '~/utils/Price/Price';

import { ProductComputedPrice } from './ProductComputedPrice';
import { ReferencePrice } from './ReferencePrice';

export interface RawReferencePrice {
	readonly sourcePrice: RawProductPrice;
	readonly calculatedPrice: {
		readonly type: string;
		readonly description: string;
		readonly selected: boolean;
		readonly sourceCurrencyPrice: Price;
		readonly targetCurrencyPrice: Price;
		readonly exchangeRate: {
			value: string;
			factor: string;
		};
	};
}

export function mapReferencePrice(referencePrice: RawReferencePrice): ReferencePrice {
	return new ReferencePrice(
		mapProductPrice(referencePrice.sourcePrice),
		new ProductComputedPrice(
			referencePrice.calculatedPrice.type,
			new Price(
				referencePrice.calculatedPrice.sourceCurrencyPrice.value,
				referencePrice.calculatedPrice.sourceCurrencyPrice.currency
			),
			referencePrice.calculatedPrice.description,
			referencePrice.calculatedPrice.selected,
			new Price(
				referencePrice.calculatedPrice.targetCurrencyPrice.value,
				referencePrice.calculatedPrice.targetCurrencyPrice.currency
			),
			referencePrice.calculatedPrice.exchangeRate
		)
	);
}
